import axios from "axios";
import {APIS} from "../../../../static/apis";

export function sendPayeesRequest(uuid: string) {
  return axios.get(
  APIS.BASE_AUTH_MS_URL + APIS.SEND_PAYEES_REQUEST + '/' + uuid
  );
}
